import { MapDispatchToProps, MapStateToPropsFactory } from "react-redux";

import { BetslipApplicationState } from "../../store/state/BetslipApplicationState";
import { getBettingResolvers } from "../../store/state/sportsbook-betting/betting-resolver";
import { getSportsbookBettingRunners } from "../../store/state/sportsbook-betting/sportsbook-betting-selectors";
import { getBetslipGroup } from "../../store/state/betslip-module/betslip-module-selectors";
import { Region } from "@ppb/the-wall-icons/traps";
import { buildBaseCastRunner, buildOrderedCastRunner } from "../betslip-mapper";
import type { BetslipLocalization, SportsbookBetslipCapabilities } from "../../contract";

export type StateProps = {
  id: string;
  horse: string;
  icon?: React.ReactNode;
  position?: number;
  positionOrdinal?: string;
  meetingCountry?: Region;
  trap?: number | string;
  isTrapIconEnabled?: boolean;
};

export type ContainerProps = {
  id: string;
  isOrderable?: boolean;
  localization: BetslipLocalization;
  capabilities: SportsbookBetslipCapabilities;
};

export const makeMapStateToProps: MapStateToPropsFactory<StateProps, ContainerProps, BetslipApplicationState> = () => {
  return (state: BetslipApplicationState, { id, isOrderable, localization, capabilities }) => {
    const group = getBetslipGroup(state);
    const resolvers = getBettingResolvers(group);
    const metadata = resolvers.getMetadata(state);
    const runners = getSportsbookBettingRunners(state);
    const runner = runners[id];
    const runnerMetadata = metadata[id];
    const castRunner = isOrderable
      ? buildOrderedCastRunner(runner, runnerMetadata, localization)
      : buildBaseCastRunner(runnerMetadata, localization);

    return {
      ...castRunner,
      id,
      isTrapIconEnabled: capabilities.trapIcon.enabled,
    };
  };
};

export type DispatchProps = Record<string, never>;

export const mapDispatchToProps: MapDispatchToProps<DispatchProps, ContainerProps> = () => ({});
